export default __webpack_public_path__ + "static/media/icon_collect_status_ing.bbbd25c1.png";